import styled from '@emotion/styled';

interface Document {
	name: string;
	url: string;
}

const Section = styled.section`
	padding: 2rem 1.5rem 4rem;
	background: #f5f5f5;
`;

const Title = styled.h2`
	font-size: 2rem;
	text-transform: uppercase;
	margin-bottom: 1.5rem;
`;

const List = styled.div`
	max-width: 64rem;
	margin: 0 auto;
	display: grid;
	gap: 1rem;
`;

const Item = styled.a`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 1.5rem;
	background: white;
	border: 1px solid #d1d5db;
	text-decoration: none;
	color: inherit;
`;

export default function DocumentBlockZeta({ documents }: { documents: Document[] }) {
	if (documents.length === 0) return null;

	return (
		<Section id="documents">
			<Title>Documents</Title>
			<List>
				{documents.map((doc) => (
					<Item key={doc.url} href={doc.url} target="_blank" rel="nofollow">
						<span>{doc.name}</span>
						<span>PDF</span>
					</Item>
				))}
			</List>
		</Section>
	);
}
